/**
 * JGQ — Filet anti double-booking avant checkout
 * POST …/shopify_checkout_validation/validate_cart
 * Line items: _jgq_item_id + Date de début/fin
 */
(function () {
  'use strict';

  var CRM_VALIDATE_URL =
    'https://app.jeugonflablequebec.ca/index.php/shopify_checkout_validation/validate_cart';

  function prop(item, key) {
    var props = item.properties || {};
    if (props[key] != null && props[key] !== '') return String(props[key]);
    var lower = key.toLowerCase();
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (String(k).toLowerCase() === lower && props[k] != null && props[k] !== '') {
        return String(props[k]);
      }
    }
    return '';
  }

  function buildLineItems(cart) {
    var lines = [];
    (cart.items || []).forEach(function (item) {
      var crmId = prop(item, '_jgq_item_id') || prop(item, 'jgq_item_id') || '';
      var start =
        prop(item, 'Date de début') ||
        prop(item, 'date_debut') ||
        prop(item, 'start_date') ||
        '';
      var end =
        prop(item, 'Date de fin') ||
        prop(item, 'date_fin') ||
        prop(item, 'end_date') ||
        start;
      if (!crmId || !start) return;
      lines.push({
        crm_item_id: crmId,
        title: item.product_title || item.title || '',
        quantity: item.quantity || 1,
        start_date: start,
        end_date: end || start,
      });
    });
    return lines;
  }

  function showBlock(messages) {
    var text =
      (messages && messages.length
        ? messages.join('\n')
        : 'Certaines dates ne sont plus disponibles. Modifiez votre panier.') +
      '\n\nAucun paiement n’a été effectué.';
    console.warn('[CHECKOUT BLOCK]', text);
    window.alert(text);
  }

  /**
   * @param {function(boolean):void} callback
   */
  window.jgqValidateCartAvailability = function (callback) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var lineItems = buildLineItems(cart);
        if (!lineItems.length) {
          callback(true);
          return null;
        }
        return fetch(CRM_VALIDATE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line_items: lineItems }),
          cache: 'no-store',
        }).then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        });
      })
      .then(function (res) {
        if (res == null) return;
        if (!res.ok || !res.data) {
          showBlock(['Impossible de vérifier la disponibilité. Réessayez.']);
          callback(false);
          return;
        }
        if (res.data.valid) {
          callback(true);
          return;
        }
        showBlock(
          (res.data.errors || []).map(function (e) {
            return e.message_fr || e.message || 'Dates non disponibles';
          })
        );
        callback(false);
      })
      .catch(function () {
        showBlock(['Impossible de vérifier la disponibilité. Réessayez.']);
        callback(false);
      });
  };

  function withAvailability(next) {
    return function () {
      var args = arguments;
      var self = this;
      if (typeof window.jgqValidateCartAvailability !== 'function') {
        return next.apply(self, args);
      }
      window.jgqValidateCartAvailability(function (ok) {
        if (!ok) return;
        next.apply(self, args);
      });
    };
  }

  function wrapNamed(fnName) {
    var prev = window[fnName];
    if (typeof prev !== 'function' || prev.__jgqAvailWrapped) return;
    if (prev.toString().indexOf('jgqValidateCartAvailability') !== -1) return;
    var wrapped = withAvailability(prev);
    wrapped.__jgqAvailWrapped = true;
    window[fnName] = wrapped;
  }

  function runDeliveryThen(next) {
    if (
      window.JgqDeliveryCalculator &&
      typeof window.JgqDeliveryCalculator.validateBeforeCheckout === 'function'
    ) {
      window.JgqDeliveryCalculator.validateBeforeCheckout(function (ok, msg) {
        if (!ok) {
          window.alert(
            msg ||
              'Veuillez terminer le calcul de livraison (ou choisir la cueillette) avant de payer.'
          );
          var calc = document.querySelector('[data-jgq-delivery-calculator]');
          if (calc) {
            try {
              calc.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } catch (e) {}
          }
          return;
        }
        next();
      });
      return;
    }
    next();
  }

  function boot() {
    wrapNamed('jgqProceedPageCheckout');
    wrapNamed('jgqSubmitCheckout');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(boot, 50);
    });
  } else {
    setTimeout(boot, 50);
  }

  // Dernier filet — ne pas court-circuiter #checkout / drawer (handlers dédiés)
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest(
        'a[href="/checkout"], a[href$="/checkout"], button[name="checkout"], [name="checkout"]'
      );
      if (!a) return;
      if (a.id === 'CartDrawer-Checkout' || a.id === 'checkout') return;
      if (a.dataset.jgqCheckoutOk === '1') {
        a.dataset.jgqCheckoutOk = '';
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      function proceed() {
        a.dataset.jgqCheckoutOk = '1';
        if (a.tagName === 'A' && a.href) window.location.href = a.href;
        else a.click();
      }

      runDeliveryThen(function () {
        if (typeof window.jgqValidateCartAvailability === 'function') {
          window.jgqValidateCartAvailability(function (ok) {
            if (!ok) return;
            proceed();
          });
        } else {
          proceed();
        }
      });
    },
    true
  );
})();
